import { render } from "./NotificationConfiguration.vue?vue&type=template&id=4506a2f6"
import script from "./NotificationConfiguration.vue?vue&type=script&lang=js"
export * from "./NotificationConfiguration.vue?vue&type=script&lang=js"

import "./NotificationConfiguration.vue?vue&type=style&index=0&id=4506a2f6&lang=scss"

import exportComponent from "/home/github-runner/actions-runner/_work/acutame/acutame/src/main/front/merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__